import outliers from '@compass-nft/outliers';

export default function sortData({ data, filterOutliers }) {
  if (filterOutliers) {
    return data.filter(outliers('value', 2.5));
  }

  return data;
}
